<template>
  <crud-form
    v-model="payload"
    :total-group="1"
    :request-class="requestClass"
    :page-title="setPageTitle"
    :override-create-payload="overrideBeforeCreate"
    :override-set-entity-data="overrideSetEntityData"
    :override-edit-payload="overrideBeforeEdit"
    navigate-back-route="Messages"
    navigate-page-after-save="Messages"
  >
    <template slot="group-1">
      <v-layout>
        <v-flex
          xs12
          lg12
        >
          <v-layout>
            <form-group title="Informações sobre a mensagem">
              <v-layout>
                <v-flex
                  xs12
                  lg12
                >
                  <v-layout
                    justify-end
                  >
                    <v-flex xs8>
                      <p>Situação</p>
                      <input-radio
                        v-model="payload.desativado"
                        :options="situationOptions"
                        row
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <input-text
                        id="input:descricao"
                        v-model="payload.descricao"
                        label="Descrição da mensagem"
                        outlined
                        required
                        :rules="[requiredRule]"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout
                    align-center
                    justify-center
                  >
                    <v-flex
                      xs6
                      lg6
                      md6
                    >
                      <message-days-combox
                        v-model="days"
                        clearable
                        multiple
                        small-chips
                        flat
                        deletable-chips
                        @updated="ev => days = ev"
                      />
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox
                        id="input:considerarApenasDiaUtil"
                        v-model="payload.considerarApenasDiaUtil"
                        label="Apenas dias úteis"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </form-group>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              lg12
            >
              <form-group title="Conteúdo da mensagem">
                <v-layout>
                  <v-flex
                    lg12
                    xs12
                  >
                    <v-tabs
                      v-model="tabs"
                      slider-color="primary"
                    >
                      <v-tab>
                        Email
                      </v-tab>
                      <v-tab>
                        Push
                      </v-tab>
                      <v-tab>
                        SMS
                      </v-tab>

                      <v-tab-item class="mt-4">
                        <v-layout>
                          <v-flex
                            xs12
                            lg12
                          >
                            <v-layout>
                              <v-flex xs9>
                                <input-text
                                  id="input:tituloDoEmail"
                                  v-model="payload.tituloDoEmail"
                                  label="Título do e-email"
                                  v-bind="isRequired('mensagemDeEmail')"
                                />
                              </v-flex>
                              <v-flex xs3>
                                <preview-code-modal
                                  v-model="payload.mensagemDeEmail"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-flex xs12>
                                <vue-editor-code
                                  id="input:mensagemDeEmail"
                                  :value="payload.mensagemDeEmail"
                                  @update-code="ev => payload.mensagemDeEmail = ev"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              justify-end
                            >
                              <v-flex xs3>
                                <message-test-send
                                  v-model="payload"
                                  label="E-mail do cliente"
                                  btn-text="Testar e-mail"
                                  type="email"
                                  :disabled="isDisabled('mensagemDeEmail')"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>

                      <v-tab-item class="mt-4">
                        <v-layout>
                          <v-flex
                            lg12
                            xs12
                          >
                            <v-layout>
                              <v-flex xs9>
                                <input-text
                                  id="input:tituloDoPush"
                                  v-model="payload.tituloDoPush"
                                  label="Título do push"
                                  v-bind="isRequired('mensagemDePush')"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-flex xs12>
                                <input-text-area
                                  id="input:mensagemDePush"
                                  v-model="payload.mensagemDePush"
                                  label="Mensagem do push"
                                  v-bind="isRequired('tituloDoPush')"
                                  rows="5"
                                  outlined
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              justify-end
                            >
                              <v-flex xs3>
                                <message-test-send
                                  v-model="payload"
                                  label="ID/CPF do cliente"
                                  btn-text="Testar Push"
                                  type="push"
                                  :disabled="isDisabled('mensagemDePush')"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>

                      <v-tab-item class="mt-4">
                        <v-layout>
                          <v-flex
                            xs12
                            lg12
                          >
                            <v-layout>
                              <v-flex xs12>
                                <input-text-area
                                  id="input:mensagemDeSms"
                                  v-model="payload.mensagemDeSms"
                                  label="Mensagem do SMS"
                                  rows="5"
                                  outlined
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              justify-end
                            >
                              <v-flex xs3>
                                <message-test-send
                                  v-model="payload"
                                  label="Telefone do cliente"
                                  btn-text="Testar SMS"
                                  type="sms"
                                  :disabled="isDisabled('mensagemDeSms')"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>
                    </v-tabs>
                  </v-flex>
                </v-layout>
              </form-group>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from 'Support/components/crud/CrudForm.vue';
import MessageRequest from 'Domain/generate-messages/MessageRequest';
import FormGroup from 'Support/layout/FormGroup.vue';
import InputRadio from 'Support/components/inputs/InputRadio.vue';
import InputText from 'Support/components/inputs/InputText.vue';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import rulesMixin from 'Support/mixins/rules-mixin';
import MessageDaysCombox from './MessageDaysCombox.vue';
import MessageTestSend from './MessageTestSend.vue';
import VueEditorCode from './components/VueEditorCode.vue';
import PreviewCodeModal from './components/PreviewCodeModal.vue';

export default {
  name: 'MessageForm',
  components: {
    CrudForm,
    FormGroup,
    InputRadio,
    InputText,
    InputTextArea,
    MessageDaysCombox,
    MessageTestSend,
    VueEditorCode,
    PreviewCodeModal,
  },
  mixins: [rulesMixin],
  data: () => ({
    requestClass: MessageRequest,
    tabs: null,
    testValue: '',
    html: '',
    days: [],
    payload: {
      considerarApenasDiaUtil: false,
      desativado: false,
      descricao: '',
      diasParaEnviar: '',
      id: '',
      mensagemDeEmail: '',
      mensagemDePush: '',
      mensagemDeSms: '',
      tituloDoEmail: '',
      tituloDoPush: '',
    },
    situationOptions: [
      {
        label: 'Ativado',
        value: true,
      },
      {
        label: 'Desativado',
        value: false,
        color: 'primary',
      },
    ],
  }),
  computed: {
    setPageTitle() {
      return this.getId ? 'Editar mensagem de alerta' : 'Adicionar mensagem de alerta';
    },
    getId() {
      return this.$route.params.id || this.payload.id;
    },
    isRequired() {
      return key => ({
        required: !!(this.hasProperty(key)),
        rules: [this.setRules(key)],
      });
    },
    hasProperty() {
      return key => this.payload && this.payload[key];
    },
    setRules() {
      return key => (this.hasProperty(key) ? this.requiredRule : this.fakeRule());
    },
    isDisabled() {
      return key => !(this.hasProperty(key));
    },
  },
  methods: {
    fakeRule() {
      return () => true;
    },
    overrideSetEntityData(data) {
      this.setFormatDays(data);
      return { ...data };
    },
    setFormatDays(data) {
      this.days = data.diasParaEnviar ? data.diasParaEnviar.split(',')
        .map(item => item.replace('D', '')) : [];
    },
    overrideBeforeCreate() {
      return {
        ...this.payload,
        diasParaEnviar: this.formatDays(),
      };
    },
    formatDays() {
      return this.days.map(day => `D${day}`).join(',');
    },
    overrideBeforeEdit() {
      return {
        ...this.payload,
        diasParaEnviar: this.formatDays(),
      };
    },
  },
};
</script>

<style>

</style>
